import { useFlags } from 'launchdarkly-react-client-sdk'

import { camelToSnake } from '@flecto/utils'

import { FeatureFlagsDefaults, type FeatureFlags } from '../types/FeatureFlags'

export function useFeatureFlags() {
  const flags: FeatureFlags = FeatureFlagsDefaults
  const ldFlags = useFlags()

  for (const flag in ldFlags) {
    const key = camelToSnake(flag).toUpperCase() as keyof FeatureFlags

    // Avoid adding FFs that are not defined on local flags definition
    if (key in flags) {
      flags[key] = ldFlags[flag]
    }
  }

  return flags
}
